import isNumber from 'lodash/isNumber';
import { translate } from 'src/app/project/features/translate/translate';
import { getFontFamily } from 'src/app/project/modules/white-label/white-label-utils/get-font-family';

export const getNoDataPlugin = (isExport = false): any => ({
  id: 'noData',
  afterDraw(chart: any): void {
    const hasData = chart.data.datasets.some(
      (dataset) =>
        dataset.data &&
        dataset.data.length > 0 &&
        dataset.data.some((value) => isNumber(value) && value > 0),
    );

    if (!hasData) {
      const { ctx, chartArea } = chart;
      ctx.save();
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = '#999';
      ctx.font = `${isExport ? 56 : 16}px ${getFontFamily()}`;
      ctx.fillText(
        translate('no_data_available'),
        (chartArea.left + chartArea.right) / 2,
        (chartArea.top + chartArea.bottom) / 2,
      );
      ctx.restore();
    }
  },
});
